<!-- BR#170 Mbeng 06/04/2026 Provide a announcements tab -->
<template>
    <div class="announcements">
      <!-- Header Section -->
      <Header class="responsive-bar">
        <template v-slot:title>
          {{ $t("announcements") }}
        </template>
      </Header>
  
      <!-- <div class="bg-gray-50 shadow rounded-md min-h-screen max-w-3xl m-auto sm:mt-5 py-10 px-6"> -->
      <div class="m-5">
  
        <tabs class="tab mt-4" v-model="activeTab"  :options="{ useUrlFragment: false }">
        
        <!-- BR#160 - 13/02/2026 - Removed notice1 tab - Mbeng -->
        <!-- Market buzz Tab -->
        <tab :name="$t('stop-out-level-notice')"  :title="$t('stop-out-level-notice')" id="notice1" value="notice1">
          
            <div class="relative w-full" style="height:1300px;">
               
                <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center"
                    style="border:0; clip-path: inset(30px 0 0 0);" v-if="whitelabel==='ICMTrader'">
                    <h2 style="font-weight:bold">اطلاعیه مهم: اعلام تغییر سطح استاپ اوت </h2><br>
                    
                    <p>مشتری گرامی، </p><br>
                    <p>
            لطفاً توجه داشته باشید که از امشب، ۱۹ مارس ۲۰۲۶، سطح استاپ اوت از ۰٪ به ۵٪ افزایش خواهد یافت. </p>
                    <br>
                    <p>لطفاً توصیه می‌شود که موقعیت‌های خود را به دقت زیر نظر داشته باشید و اطمینان حاصل کنید که حساب‌های شما به</p>
                    <p>میزان کافی تأمین مالی شده‌اند تا از رسیدن به سطح استاپ اوت جلوگیری شود</p><br>
                    <p>با احترام، </p>
                    <p>تیم  ICM Trader </p><br>
                </div>
                <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center"
                    style="border:0; clip-path: inset(30px 0 0 0);" v-else>
                    <p></p>
                    <p></p>
                    <br>
                    <h2 style="font-weight:bold">
                    Important Notice: Stop out level adjustment notice
                    </h2>

                    
                    <br>
                    <p>Dear Valued client</p>
                    <br>

                    <p>
                    Please be informed that effective March 19, 2026, the stop out level will be
                    </p>
                    <p>increased from 0% to 5%.</p>

                    <br>

                    <p>
                    We kindly advise you to monitor your positions closely and ensure that your
                    </p>
                    <p>
                    accounts are sufficiently funded to avoid reaching the stop out level.
                    </p>

                    <br>

                    <p>Best regards</p>
                </div>

                 <div class="absolute top-0 left-0 w-full h-[50px] bg-white z-10 pointer-events-none"></div>
               
            </div>
        </tab>

        <!-- Tax detail popup Tab -->
        <tab :name="$t('tax-details')" :title="$t('tax-details')" id="notice2" value="notice2" v-if="whitelabel==='ICMMU'">
          
            <div class="relative w-full" style="height:1300px;">

            
              <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center" style="border:0; clip-path: inset(30px 0 0 0);">

                <!-- Header -->
                <div class="flex items-center justify-center mb-3">
                  <h3 class="text-lg font-semibold text-yellow-700">
                    {{ $t("important-information") }}
                  </h3>
                </div>

                <!-- Content -->
                <p class="text-sm text-gray-700 mb-4">
                  {{ $t("to-comply-with-regulatory-requirements-you-are-required-to-provide") }}
                  <strong>30-08-2026.</strong>
                </p>

                <!-- <p class="text-sm text-gray-700 mt-2 mb-4">
                  {{ $t("failure-to-complete-this-step-by-the-deadline-will-result-in-limited-access") }}
                </p> -->

                <!-- <p>
                  {{ $t("time-left") }}: <strong>{{ timeLeft }}</strong>
                </p>

                <br>
                <router-link
                  to="/tax-details"
                  class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                  v-if="shouldShow"
                >
                  {{ $t('complete-now') }} →
                </router-link> -->
            </div>

          </div>
        </tab>
         <!-- BR#175 vc closing popup Tab -->
        <tab :name="$t('popup-important-notice ')" :title="$t('popup-important-notice ')" id="notice3" value="notice3" v-if="whitelabel==='ICMVC'">
          
            <div class="relative w-full" style="height:1300px;">

            
              <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center" style="border:0; clip-path: inset(30px 0 0 0);">

                <!-- Header -->
                <div class="flex items-center justify-center mb-3">
                  <h3 class="text-lg font-semibold text-yellow-700">
                    {{ $t("popup-important-notice ") }}
                  </h3>
                </div>

                <!-- Content -->
                <h2 style="font-weight:bold">
                    <!-- {{ $t("popup-important-notice") }} -->
                    </h2>
                    <br>
                    <p>{{ $t("your-current-icm-account-is") }}</p>
                    <br>
                    <p>
                     {{ $t("to-continue-trading-without") }}
                    </p>
                    <br>
                    <p>
                     {{ $t("if-you-have-any-remaining-balance") }}
                    </p>
            </div>

          </div>
        </tab>
        <!-- BR#179 mu closing swapfree accounts popup Tab mbeng - 27/04/2026-->
        <tab :name="$t('swapfree-notice')" :title="$t('swapfree-notice')" id="notice4" value="notice4" v-if="whitelabel==='ICMMU'">
          
            <div class="relative w-full" style="height:1300px;">

            
              <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center" style="border:0; clip-path: inset(30px 0 0 0);">

                <!-- Header -->
                <div class="flex items-center justify-center mb-3">
                  <h3 class="text-lg font-semibold text-yellow-700">
                    {{ $t("important-swap-free-discontinued") }}
                  </h3>
                </div>

                <!-- Content -->
                <h2 style="font-weight:bold">
                    <!-- {{ $t("popup-important-notice") }} -->
                    </h2>
                    <br>
                    <p v-html="$t('effective-monday-27-april-2026')"></p>
                    <br>
                    <p>
                     {{ $t("please-review-any-position-in-advance") }}
                    </p>
            </div>

          </div>
        </tab>
        <!-- BR#181 Mbeng - 13/05/2026 - mu - High risk country popup Tab -->
        <tab :name="$t('sof-notice')" :title="$t('sof-notice')" id="notice5" value="notice5" v-if="whitelabel==='ICMMU' && isHighRiskCountry">
          
            <div class="relative w-full" style="height:1300px;">

            
              <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center" style="border:0; clip-path: inset(30px 0 0 0);">

                
                <div class="flex items-center justify-center mb-3">
                  <h3 class="text-lg font-semibold text-yellow-700">
                    <!-- {{ $t("important-sof-form") }} -->
                  </h3>
                </div>

              
                <h2 style="font-weight:bold">
                    
                    </h2>
                    <p>
                     {{ $t("as-part-of-our-standard-onboarding-and-compliance-procedures") }}
                    </p>
                    <br>
                    <p><a
                      :href="computedPdfUrl || null"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="text-blue-600 hover:underline { 'pointer-events-none opacity-50': !computedPdfUrl }"
                    >
                     {{ $t("click-here-to-download") }}
                    </a></p>
                    <br>
                    <p>
                     {{ $t("once-completed-you-may-upload-the-signed") }}
                    </p>
            </div>

          </div>
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Header from "@/components/Header";
import { Tabs, Tab } from 'vue-tabs-component';
import Vue from "vue";
import VueI18Next from "@panter/vue-i18next";
import i18next from "i18next";
import { nextTick } from 'vue';


Vue.use(VueI18Next);
const i18n = new VueI18Next(i18next);

export default {
  name: "Annoucement",
  components: {
    Header,
    Tabs,
    Tab,
  },
  props: {
        visible: {
            type: Boolean,
            required: true
        },
        countdown: {
            type: Number,
            default: 0,
        },
        deadline: {
            type: Date,
            required: true
        },
    },
  data() {
    return {
      activeTab: "notice1", // default
      whitelabel: process.env.VUE_APP_WHITELABEL,
      timeLeft: '',   
      countdownTimer: null
    };
  },

  computed: {
    ...mapGetters(["get_profile", "get_country_risk_map"]),
    lang() {
      let language = this.$store.getters.get_lang;
      if (language === "zh-Hant") {
        language = "zh-hant";
      }
      if (language === "zh-Hans") {
        language = "zh-hans";
      }
      return language;
    },

    shouldShow() {
        const profileType = this.get_profile?.profile?.type;
        const nicFields = this.get_profile?.nic_fields || [];

        // Filter priority 3-6 fields with code 'TIN' and non-empty value
        const hasValidTIN = [3,4,5,6].some(priority => {
          const field = nicFields.find(n => n.priority === priority);
          return field && field.code === 'TIN' && field.value && field.value?.toString().trim() !== '';
        });

        return this.whitelabel === 'ICMMU' && !hasValidTIN;
      },
      //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
    countryCode() {
      return this.get_profile?.address?.addr_country_iso_code?.trim()?.toUpperCase() || null;
    },

    normalizedRiskMap() {
      const raw = this.get_country_risk_map;

      if (Array.isArray(raw)) return raw;

      if (raw && typeof raw === "object") {
        if (Array.isArray(raw.data)) return raw.data;

        return Object.entries(raw).map(([iso_code, risk_type]) => ({
          iso_code,
          risk_type
        }));
      }

      return [];
    },

    isHighRiskCountry() {
      if (!this.countryCode) {
        return false;
      }

      if (!this.normalizedRiskMap.length) {
        return false;
      }

      const match = this.normalizedRiskMap.find(
        c => c.iso_code === this.countryCode
      );

      const riskType = match?.risk_type;
      return riskType === "High risk" || riskType === "Other";
    },

    userLanguage() {
        return this.get_profile?.profile?.language;
      },
      
    computedPdfUrl() {
      const lang = this.$store.getters.get_lang || 'en';  

      const mapICMMU = {
        en: '/ICMMU-Source-of-Funds-and-Wealth-Declaration-Form.pdf',
        ar: '/ICMMU-Source-of-Funds-and-Wealth-Declaration-Form-AR.pdf',
      };

      const whitelabel = process.env.VUE_APP_WHITELABEL;

      if (whitelabel === 'ICMMU') {
        return mapICMMU[lang] || mapICMMU.en;
      } 

      return mapICMMU.en; // fallback

    }
  },
  
  mounted() {
    this.activeTab = "notice1";
    this.startCountdown();
       
  },
  watch: {
    activeTab(newVal) {
        // if (this.$route.hash !== `#${newVal}`) {
        // this.$router.replace({ hash: `#${newVal}` });
        // }
    },
  },
 created() {},
 methods: {}
};
</script>
  
<style>
.tabs-component {
  margin-bottom: 1.5rem;
}

/* Container holding the tabs */
.tabs-component-tabs {
  display: flex;              /* make them horizontal */
  flex-direction: row;
  background: #f9f9f9;
  border-bottom: 2px solid #ddd;
  padding: 0;
  margin: 0;
}

/* Each tab */
.tabs-component-tab {
  list-style: none;
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  background: transparent;
  color: #333;
  font-weight: 500;
  transition: all 0.3s ease;
  border-radius: 6px 6px 0 0; /* rounded top corners */
  margin-right: 5px;
}

/* Hover effect */
.tabs-component-tab:hover {
  background: #eaeaea;
  color: #0d4778; 
}

/* Active tab */
.tabs-component-tab.is-active {
  background: #0d4778; 
  color: #fff;
  border-bottom: none;
}


.tabs {
  font-family: Arial, sans-serif;
}

.tab-headers {
  display: flex; 
  gap: 10px;
  margin-bottom: 10px;
}

.tab-headers button {
  padding: 10px 20px;
  border: none;
  background-color: #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.tab-headers button.active {
  background-color: #0d4778; 
  color: white;
}

.tab-content {
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}
</style>


